module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "row vertical-align-center"
  }, [_c('div', {
    staticClass: "dataTables_length col-sm-4"
  }, [_c('label', [_vm._v("Show\n                    "), _c('select', {
    staticClass: "form-control input-sm",
    on: {
      "change": _vm.onPageSizeChange
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])]), _vm._v(" entries\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary new-btn col-sm-offset-1 col-sm-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showSubscriptionDialog()
      }
    }
  }, [_vm._v("New\n                  subscription\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_filter",
    attrs: {
      "id": "search_filter"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-primary search-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'name'
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('name', 'true')
      }
    }
  }, [_vm._v("Name\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Subscribers")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'frequency'
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('frequency', 'true')
      }
    }
  }, [_vm._v("Frequency\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Area")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    class: {
      active: _vm.sortField === 'creationDate'
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('creationDate', 'true')
      }
    }
  }, [_vm._v("Subscription date\n                  ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), (!_vm.subscriptions.length) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("No data found")]) : _c('tbody', _vm._l((_vm.subscriptions), function(subscription) {
    return _c('tr', {
      staticClass: "even clickable",
      attrs: {
        "role": "row"
      },
      on: {
        "click": function($event) {
          return _vm.showSubscriptionDialog(subscription)
        }
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(subscription.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subscription.emails.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subscription.frequency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subscription.zone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("prettyDateTime")(subscription.creationDate)))]), _vm._v(" "), _c('td', {
      staticClass: "row-actions"
    }, [_c('i', {
      staticClass: "far fa-edit",
      attrs: {
        "title": "Edit"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "far fa-trash-alt",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteSubscription(subscription._id)
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), (_vm.subscriptions.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "align-infos col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_info",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_vm._v("\n                Showing " + _vm._s(_vm.total - _vm.subscriptions.length + 1 > (_vm.page + 1) * _vm.size - 1 ? (_vm.page + 1) * _vm.size - 1 : _vm.total - _vm.subscriptions.length + 1) + "\n                to " + _vm._s(_vm.total > (_vm.page + 1) * _vm.size ? (_vm.page + 1) * _vm.size : _vm.total) + " of " + _vm._s(_vm.total) + " entries\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-pagination col-sm-12"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.pageTotal,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.onPageChange,
      "prev-text": 'Prev',
      "force-page": _vm.page,
      "next-text": 'Next',
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('new-subscription-modal', {
    ref: "subscription-modal",
    attrs: {
      "id": "new-subscription-modal"
    },
    on: {
      "remove": _vm.deleteSubscription,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Subscriptions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36b810f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Subscriptions.vue
// module id = 433
// module chunks = 1